window.addEventListener('load', () => {
    setTimeout(function() {
    const accordion = document.querySelector('.app-site-content-accordion');
    if(typeof(accordion) != 'undefined' && accordion != null && !document.querySelector('.neos-backend')) {
        const items = document.querySelectorAll('.app-site-content-accordion-item');
        let openCount = 0;
        items.forEach((item) => {

            const content = item.querySelector('.app-site-content-accordion-item-content');
            const content2 = item.querySelectorAll('.app-site-content-accordion-collection')[0];

            if(!content || (content2 && content2.innerHTML === "")){
                //console.log('else');
                item.querySelector('.app-site-content-accordion-item-title').classList.add('no-content');
            }

            item.querySelectorAll('.app-site-content-accordion-item-title')[0].addEventListener('click', () => {

                if(content){
                    //console.log('true');
                    item.classList.toggle('active');

                    if (content.style.display === "block") {
                        content.style.display = "none";
                        openCount--;
                    } else {
                        content.style.display = "block";
                        openCount++;
                    }
                    if (0 < openCount) {
                        if (history.scrollRestoration) {
                            history.scrollRestoration = 'manual';
                        } else {
                            window.onbeforeunload = () => {
                                window.scrollTo(0,0);
                            };
                        }
                    } else {
                        history.scrollRestoration = 'auto';
                        window.onbeforeunload = () => {};
                    }
                }
            })
        })
    }
    },300);
})
